import React, { Component } from 'react';
import styled from 'styled-components';
import i18n from '../../config/i18n';

const StyledBar = styled.div`
  background-color: #ecf0f1;
  color: #95a5a6;
  display: block;
  margin-top: 50px;

  @media screen and (min-width: 768px) {
    margin-top: 72px;
  }
`;

const StyledUserInfo = styled.div`
  margin-right: 15px;
`;

class StatusBar extends Component {
  render() {
    const { email } = this.props;

    return (
      <StyledBar>
        <div className="container">
          <div className="breadcrumb-section pull-left">
            <a href="/dashboard"><i className="glyphicon glyphicon-home" /></a>
          </div>
          <div className="logout-section pull-right text-right">
            <a href="/logout"><i className="glyphicon glyphicon-log-out" /></a>
          </div>
          <StyledUserInfo className="info-section pull-right text-right">
            {i18n.t('user')}: {email || i18n.t('notLoggedIn')}
          </StyledUserInfo>
        </div>
      </StyledBar>
    );
  }
}

export default StatusBar;



// WEBPACK FOOTER //
// ./src/components/shared/StatusBar.js